<template>
    <simple-layout vertical>
        <template v-if="!loading">
            <basic-card>
                <template slot="header">
                    Basic Criteria
                </template>
                <form-wrapper>
                    <form-select-input v-model="source" :options="sourceOptions" caption="Source"/>
                    <form-select-input v-model="currency" :options="currencyOptions" caption="Currency"/>
                </form-wrapper>
                <simple-button @press="reloadData">Load data</simple-button>
            </basic-card>
            <basic-card>
                <template slot="header">
                    Credit report
                </template>
<!--                <filter-form-->
<!--                    :filter-definition="filterDefinition"-->
<!--                    :value="creditFilter"-->
<!--                />-->
                <form-wrapper>
                    <form-text-input caption="Quick filter" v-model="partyFilter"/>
                </form-wrapper>
                <data-table
                        :data="filteredCreditRisk"
                        :configuration="creditRiskTableConfig"
                />
            </basic-card>
        </template>
        <template v-else>
            <basic-card>
                <loader indefinite message="Loading credit risk data"/>
            </basic-card>
        </template>
    </simple-layout>
</template>

<script>
    import BasicCard from "../components/layout/BasicCard";
    import SimpleLayout from "../components/layout/SimpleLayout";
    import FormWrapper from "../components/form/FormWrapper";
    import {mapGetters} from "vuex";
    import FormSelectInput from "../components/form/FormSelectInput";
    import SimpleButton from "../components/button/SimpleButton";
    import DataTable from "../components/table/DataTable";
    import Loader from "../components/Loader";
    import chroma from "chroma-js"
    import FormTextInput from "../components/form/FormTextInput";
    import FilterForm from "../components/filters/FilterForm";
    import QueryUtils from "../utils/QueryUtils";

    export default {
        name: "CreditRiskView",
        components: {
            FilterForm,
            FormTextInput,
            Loader, DataTable, SimpleButton, FormSelectInput, FormWrapper, SimpleLayout, BasicCard},
        data: function() {
            return {
                source: "frontend",
                currency: "CZK",
                creditRisk: [],
                partyFilter: "",
                loading: true,
                creditFilter: { parameters: {} }
            }
        },
        methods: {
            reloadData() {
                this.loading = true;
                this.$store.dispatch(`creditRisk/refreshPaymentPerformance`, { source: this.source, currency: this.currency})
                    .then(data => {
                        this.loading = false;
                        this.creditRisk = data
                    });
            }
        },
        computed: {
            ... mapGetters({
                cashEventFieldValues: "cashEventFieldDistincts/fieldValues",
                currencyOptions: "currencies/currenciesOptions",
                party: "parties/party"
            }),
            filterDefinition() {
                return QueryUtils.getByType("creditRisk", { currencies: [], accounts: []});
            },
            filteredCreditRisk() {
                if(this.partyFilter != "")
                    return this.creditRisk.filter(item => this.party(item.counterParty)?.displayName?.toLowerCase().includes(this.partyFilter.toLowerCase()));
                return this.creditRisk;
            },
            sourceOptions() {
                return (this.cashEventFieldValues('source') ?? []).map(v => ({name: v, id: v}))
            },
            creditRiskTableConfig() {
                let creditColumns = (... columns) => {

                    let zeroIdx = columns.findIndex(col => col == "0");
                    return columns.map((col, colIdx) => ({
                        caption: col,
                        datum: d => this.$formats.formatAmount(d.groupedAmounts.find(grp => grp.groupName == col)?.value / 1000000),
                        style: d => {
                            let value = d.groupedAmounts.find(grp => grp.groupName == col)?.value ?? 0;
                            if(value != 0) {
                                return ({ 'background-color': chroma("#c84a4b").alpha(1 - (colIdx / zeroIdx)).hex(),
                                    'color': (colIdx / zeroIdx) < 1 ? chroma.scale(['#A8B2BD', 'white'])(1 - (colIdx / zeroIdx)).hex() : undefined })
                            }
                        }
                    }))
                };

                return {
                    columns: [
                        {
                            caption: "Party",
                            datum: d => this.party(d.counterParty).displayName
                        },
                        ... creditColumns("<-90","-60","-30","-14","0","7","14","30",">30")
                    ]
                }
            }
        },
        mounted() {
            this.$store.dispatch("cashEventFieldDistincts/refreshAllFields").then(() => {
                this.reloadData();

                this.loading = false;
            });
        }
    }
</script>

<style scoped>

</style>